var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 145,
    viewBox: "0 0 671 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.188 98.5465V144.241H605.648V139.471H566.86V98.5465C566.86 92.7278 571.497 87.9941 577.197 87.9941H605.648V83.2246H577.197C568.92 83.2246 562.188 90.0974 562.188 98.5465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.401 26.6849H643.927V31.4544H662.401C664.291 31.4544 665.828 33.0235 665.828 34.9528V57.0569H632.179V5.57758H670.458V0.808105H627.507V61.8264H670.5V34.9528C670.5 30.3955 666.868 26.6849 662.401 26.6849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.069 34.9504C511.069 30.3932 507.436 26.6825 502.97 26.6825H484.496V31.452H502.97C504.86 31.452 506.397 33.0211 506.397 34.9504V57.0545H472.748V5.57758H511.027V0.808105H468.076V61.8264H511.069V34.9528V34.9504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.275 0.820007H533.603V61.7572H538.275V0.820007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.35 56.9782H345.909V31.4544H379.678V26.6849H345.909V5.57758H384.35V0.808105H341.237V61.7477H384.35V56.9782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.955 61.7477H245.068V56.9782H206.627V31.4544H240.395V26.6849H206.627V5.57758H245.068V0.808105H201.955V61.7477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.608 63.2572L444.708 60.9726L428.923 31.4544H433.847C442.124 31.4544 448.857 24.5816 448.857 16.1324C448.857 7.6833 442.124 0.808105 433.847 0.808105H403.06V61.7572H407.732V31.452H423.599L440.606 63.2548L440.608 63.2572ZM407.735 5.57758H433.85C439.55 5.57758 444.187 10.3113 444.187 16.13C444.187 21.9488 439.55 26.6825 433.85 26.6825H407.735V5.57758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.365 83.2246H361.578V144.243H407.374V98.5489C407.374 90.0998 400.642 83.227 392.365 83.227V83.2246ZM402.702 139.473H366.25V87.9941H392.365C398.065 87.9941 402.702 92.7278 402.702 98.5465V139.471V139.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.362 83.2366H331.69V144.174H336.362V83.2366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.955 144.164H245.068V139.395H206.627V113.868H240.395V109.099H206.627V87.9941H245.068V83.2246H201.955V144.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.567 144.164H473.682V139.395H435.24V113.868H469.01V109.099H435.24V87.9941H473.682V83.2246H430.567V144.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.594 139.395H280.819L266.581 82.6451L262.056 83.828L277.194 144.164H292.219L307.359 83.828L302.832 82.6451L288.594 139.395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.346 144.164H670.458V139.395H632.018V113.868H665.786V109.099H632.018V87.9941H670.458V83.2246H627.346V144.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.934 56.9782H288.215L274.145 0.808105H262.214V61.8049H266.887V5.57758H270.517L284.587 61.7477H299.559L313.669 5.57758H317.239V61.8049H321.911V0.808105H310.043L295.934 56.9782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.137 56.9782H600.329L573.884 0.808105H561.83V61.8049H566.502V5.57758H570.946L597.392 61.7477H608.809V0.922573H604.137V56.9782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.509 139.347H534.701L508.254 83.1769H496.202V144.174H500.874V87.9464H505.315L531.762 144.117H543.181V83.2914H538.509V139.347Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.216 0.808105H0V125.186L19.2469 144.808H141V19.6189L122.216 0.827183V0.808105ZM44.4612 104.451H97.2008L114.23 121.812H44.4612V104.451ZM95.83 42.5434H43.0904L26.061 25.1825H95.83V42.5434ZM95.83 47.3129V99.6817H44.4612V47.3129H95.83ZM4.6784 5.57758H117.538V118.44L100.508 101.079V20.413H18.0727V136.867L4.6784 123.212V5.57758ZM136.324 21.6197V140.039H22.7511V28.5545L39.7804 45.9154V126.582H122.214V7.50922L136.322 21.6221L136.324 21.6197Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 641,
    height: 144,
    fill: "white",
    transform: "translate(29.5 0.808105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2Logo);
export default __webpack_public_path__ + "static/media/e2-logo.acc1077a8a5b254e7df8e44dfc61d27a.svg";
export { ForwardRef as ReactComponent };